import { Route, Routes } from 'react-router';
import { Dashboard } from './Dashboard';
import UserGroupCreate from '../pages/authority/userGroups/UserGroupCreate';
import UserGroupEdit from '../pages/authority/userGroups/UserGroupEdit';
import UserGroupPage from '../pages/authority/userGroups/UserGroupPage';
import UserPage from '../pages/authority/users/roles/UserPage';
import UserEdit from '../pages/authority/users/roles/UserEdit';
import TenantMemberEdit from '../pages/authority/users/roles/TenantMemberEdit';
import SaaSUsersPage from '../pages/authority/saasUsers/SaaSUsersPage';
import SaaSUserEdit from '../pages/authority/saasUsers/SaaSUserEdit';
import PlatformRolesPage from '../pages/authority/platformRoles/PlatformRolesPage';
import PlatformRoleEdit from '../pages/authority/platformRoles/PlatformRoleEdit';
import SystemConfigurationsPage from '../pages/systemConfigurations/SystemConfigurationPage';
import SystemConfigurationEdit from '../pages/systemConfigurations/SystemConfigurationEdit';
import TagCreate from '../pages/tags/TagCreate';
import TagEdit from '../pages/tags/TagEdit';
import TagsPage from '../pages/tags/TagPage';
import PublisherPage from '../pages/publishers/PublisherPage';
import PublisherCreate from '../pages/publishers/PublisherCreate';
import PublisherEdit from '../pages/publishers/PublisherEdit';
import FaqCategoryEdit from '../pages/faqCategories/FaqCategoryEdit';
import FaqCategoryPage from '../pages/faqCategories/FaqCategoryPage';
import FaqCategoryCreate from '../pages/faqCategories/FaqCategoryCreate';
import FaqsPage from '../pages/faqs/FaqPage';
import FaqCreate from '../pages/faqs/FaqCreate';
import FaqEdit from '../pages/faqs/FaqEdit';
import OfficialsPage from '../pages/officials/OfficialPage';
import OfficialCreate from '../pages/officials/OfficialCreate';
import OfficialEdit from '../pages/officials/OfficialEdit';
import OnboardingSlidesPage from '../pages/onboardingSlides/OnboardingSlidesPage';
import OnboardingSlideCreate from '../pages/onboardingSlides/OnboardingSlideCreate';
import OnboardingSlideEdit from '../pages/onboardingSlides/OnboardingSlideEdit';
import ReportsPage from '../pages/reports/ReportPage';
import ReportView from '../pages/reports/ReportView';
import ContentPage from '../pages/contents/ContentPage';
import ContentCreate from '../pages/contents/ContentCreate';
import ContentEdit from '../pages/contents/ContentEdit';
import PagePage from '../pages/pages/PagePage';
import PageCreate from '../pages/pages/PageCreate';
import PageEdit from '../pages/pages/PageEdit';
import LocationCreate from '../pages/locations/LocationCreate';
import LocationEdit from '../pages/locations/LocationEdit';
import LocationPage from '../pages/locations/LocationPage';
import PublisherTypePage from '../pages/publisherTypes/PublisherTypePage';
import PublisherTypeCreate from '../pages/publisherTypes/PublisherTypeCreate';
import PublisherTypeEdit from '../pages/publisherTypes/PublisherTypeEdit';
import MenuItemPage from '../pages/menuItems/MenuItemPage';
import ReportCategoryCreate from '../pages/reportCategories/ReportCategoryCreate';
import ReportCategoryEdit from '../pages/reportCategories/ReportCategoryEdit';
import ReportCategoryPage from '../pages/reportCategories/ReportCategoryPage';
import MapObjectCategoryCreate from '../pages/mapObjectCategories/MapObjectCategoryCreate';
import MapObjectCategoryEdit from '../pages/mapObjectCategories/MapObjectCategoryEdit';
import MapObjectCategoryPage from '../pages/mapObjectCategories/MapObjectCategoryPage';
import MapObjectCreate from '../pages/mapObjects/MapObjectCreate';
import MapObjectEdit from '../pages/mapObjects/MapObjectEdit';
import MapObjectPage from '../pages/mapObjects/MapObjectPage';
import GalleryPage from '../pages/gallery/galleryPage';
import RssSettingssPage from '../pages/rssSettings/RssSettingssPage';
import RssSettingsCreate from '../pages/rssSettings/RssSettingsCreate';
import RssSettingsEdit from '../pages/rssSettings/RssSettingsEdit';
import MobileApplicationThemesPage from '../pages/mobileApplicationThemes/MobileApplicationThemesPage';
import MobileApplicationThemeCreate from '../pages/mobileApplicationThemes/MobileApplicationThemeCreate';
import MobileApplicationThemeEdit from '../pages/mobileApplicationThemes/MobileApplicationThemeEdit';
import MobileApplicationReleaseProfilesPage from '../pages/mobileApplicationReleaseProfiles/MobileApplicationReleaseProfilesPage';
import MobileApplicationReleaseProfileCreate from '../pages/mobileApplicationReleaseProfiles/MobileApplicationReleaseProfileCreate';
import MobileApplicationReleaseProfileEdit from '../pages/mobileApplicationReleaseProfiles/MobileApplicationReleaseProfileEdit';
import EmailTemplateCreate from '../pages/emailTemplates/EmailTemplateCreate';
import EmailTemplateEdit from '../pages/emailTemplates/EmailTemplateEdit';
import EmailTemplateHomePage from '../pages/emailTemplates/EmailTemplateHomePage';
import ParkingZoneEdit from '../pages/parking/parkingZones/ParkingZoneEdit';
import ParkingZonesPage from '../pages/parking/parkingZones/ParkingZonesPage';
import ParkingZoneCreate from '../pages/parking/parkingZones/ParkingZoneCreate';
import ParkingPlaceCreate from '../pages/parking/parkingPlaces/ParkingPlaceCreate';
import ParkingPlacesPage from '../pages/parking/parkingPlaces/ParkingPlacesPage';
import ParkingPlaceEdit from '../pages/parking/parkingPlaces/ParkingPlaceEdit';
import ParkingZoneConfigCreate from '../pages/parking/parkingZoneConfigs/ParkingZoneConfigCreate';
import ParkingZoneConfigEdit from '../pages/parking/parkingZoneConfigs/ParkingZoneConfigEdit';
import ParkingZoneConfigsPage from '../pages/parking/parkingZoneConfigs/ParkingZoneConfigsPage';
import ParkingStatisticsPage from '../pages/parking/parkingStatistics/ParkingStatisticsPage';
import RssFeedCreate from '../pages/rssFeeds/RssFeedCreate';
import RssFeedEdit from '../pages/rssFeeds/RssFeedEdit';
import RssFeedsPage from '../pages/rssFeeds/RssFeedsPage';
import ParkingRead from '../pages/parking/ParkingRead';
import HtmlAppletPage from '../pages/htmlApplets/HtmlAppletPage';
import HtmlAppletCreate from '../pages/htmlApplets/HtmlAppletCreate';
import HtmlAppletEdit from '../pages/htmlApplets/HtmlAppletEdit';
import TenantPage from '../pages/tenants/TenantPage';
import TenantCreate from '../pages/tenants/TenantCreate';
import TenantEdit from '../pages/tenants/TenantEdit';
import TenantAdminPage from '../pages/tenants/TenantAdminPage';
import TenantOnboardingWizardPage from '../pages/tenants/TenantOnboardingWizardPage';
import TenantOverviewPage from '../pages/tenants/TenantOverviewPage';
import TenantGroupPage from '../pages/tenantGroups/TenantGroupPage';
import TenantGroupEdit from '../pages/tenantGroups/TenantGroupEdit';
import SubscriptionPage from '../pages/subscriptions/SubscriptionPage';
import SubscriptionCreate from '../pages/subscriptions/SubscriptionCreate';
import SubscriptionEdit from '../pages/subscriptions/SubscriptionEdit';
import LicensePage from '../pages/licenses/LicensePage';
import LicenseCreate from '../pages/licenses/LicenseCreate';
import LicenseEdit from '../pages/licenses/LicenseEdit';
import RoleCatalogPage from '../pages/roleCatalog/RoleCatalogPage';
import RoleCatalogEdit from '../pages/roleCatalog/RoleCatalogEdit';
import PlatformDashboardPage from '../pages/platform/PlatformDashboardPage';
import InvitationsPage from '../pages/invitations/InvitationsPage';
import AcceptInvitationPage from '../pages/invitations/AcceptInvitationPage';
import ProfilePage from '../pages/auth/ProfilePage';
import ResetPasswordPage from '../pages/auth/ResetPasswordPage';
import { useSelector } from 'react-redux';

const AppRoutes = () => {
  const parkingEnabled = useSelector(
    (state: any) => state.app.featureFlags?.parkingEnabled
  );
  const htmlAppletsEnabled = useSelector(
    (state: any) => state.app.featureFlags?.htmlAppletsEnabled
  );
  const appThemeEnabled = useSelector(
    (state: any) => state.app.featureFlags?.appThemeEnabled
  );
  const multiTenancyEnabled = useSelector(
    (state: any) => state.app.featureFlags?.multiTenancyEnabled
  );

  return (
    <Routes>
      <Route path="/authority/userGroups" element={<UserGroupPage />} />
      <Route
        path="/authority/userGroups/create"
        element={<UserGroupCreate />}
      />
      <Route
        path="/authority/userGroups/edit/:id"
        element={<UserGroupEdit />}
      />
      <Route path="/authority/roles" element={<PlatformRolesPage />} />
      <Route path="/authority/roles/create" element={<PlatformRoleEdit />} />
      <Route path="/authority/roles/edit/:id" element={<PlatformRoleEdit />} />
      <Route path="/authority/platform-roles" element={<PlatformRolesPage />} />
      <Route
        path="/authority/platform-roles/create"
        element={<PlatformRoleEdit />}
      />
      <Route
        path="/authority/platform-roles/edit/:id"
        element={<PlatformRoleEdit />}
      />
      <Route path="/authority/users" element={<UserPage />} />
      <Route path="/authority/users/edit/:id" element={<UserEdit />} />
      <Route path="/authority/saas-users" element={<SaaSUsersPage />} />
      <Route path="/authority/saas-users/edit/:id" element={<SaaSUserEdit />} />
      <Route
        path="/authority/users/membership/:membershipId"
        element={<TenantMemberEdit />}
      />

      <Route path="/gallery" element={<GalleryPage />} />

      <Route path="/tags" element={<TagsPage />} />
      <Route path="/tags/create" element={<TagCreate />} />
      <Route path="/tags/edit/:id" element={<TagEdit />} />

      <Route path="/rssSettings" element={<RssSettingssPage />} />
      <Route path="/rssSettings/create" element={<RssSettingsCreate />} />
      <Route path="/rssSettings/edit/:id" element={<RssSettingsEdit />} />

      <Route path="/rssFeed" element={<RssFeedsPage />} />
      <Route path="/rssFeed/create" element={<RssFeedCreate />} />
      <Route path="/rssFeed/edit/:id" element={<RssFeedEdit />} />

      {appThemeEnabled !== false && (
        <>
          <Route
            path="/mobileApplicationTheme"
            element={<MobileApplicationThemesPage />}
          />
          <Route
            path="/mobileApplicationTheme/create"
            element={<MobileApplicationThemeCreate />}
          />
          <Route
            path="/mobileApplicationTheme/edit/:id"
            element={<MobileApplicationThemeEdit />}
          />
        </>
      )}
      <Route
        path="/mobileApplicationReleaseProfile"
        element={<MobileApplicationReleaseProfilesPage />}
      />
      <Route
        path="/mobileApplicationReleaseProfile/create"
        element={<MobileApplicationReleaseProfileCreate />}
      />
      <Route
        path="/mobileApplicationReleaseProfile/edit/:id"
        element={<MobileApplicationReleaseProfileEdit />}
      />
      <Route path="/erp/emailTemplates" element={<EmailTemplateHomePage />} />
      <Route
        path="/erp/emailTemplates/create"
        element={<EmailTemplateCreate />}
      />
      <Route
        path="/erp/emailTemplates/edit/:id"
        element={<EmailTemplateEdit />}
      />
      <Route path="/publishertypes" element={<PublisherTypePage />} />
      <Route path="/publishertypes/create" element={<PublisherTypeCreate />} />
      <Route path="/publishertypes/edit/:id" element={<PublisherTypeEdit />} />

      <Route path="/publishers" element={<PublisherPage />} />
      <Route path="/publishers/create" element={<PublisherCreate />} />
      <Route path="/publishers/edit/:id" element={<PublisherEdit />} />

      <Route path="/mapobjects" element={<MapObjectPage />} />
      <Route path="/mapobjects/create" element={<MapObjectCreate />} />
      <Route path="/mapobjects/edit/:id" element={<MapObjectEdit />} />

      <Route path="/mapObjectCategories" element={<MapObjectCategoryPage />} />
      <Route
        path="/mapObjectCategories/create"
        element={<MapObjectCategoryCreate />}
      />
      <Route
        path="/mapObjectCategories/edit/:id"
        element={<MapObjectCategoryEdit />}
      />
      {parkingEnabled && (
        <>
          <Route path="/parkingZone/edit/:id" element={<ParkingZoneEdit />} />
          <Route path="/parkingZones" element={<ParkingZonesPage />} />
          <Route path="/parkingRead" element={<ParkingRead />} />
          <Route path="/parkingZone/create" element={<ParkingZoneCreate />} />
          <Route
            path="/parkingZoneConfig/edit/:id"
            element={<ParkingZoneConfigEdit />}
          />
          <Route
            path="/parkingZoneConfigs"
            element={<ParkingZoneConfigsPage />}
          />
          <Route
            path="/parkingStatistics"
            element={<ParkingStatisticsPage />}
          />
          <Route
            path="/parkingZoneConfig/create"
            element={<ParkingZoneConfigCreate />}
          />
          <Route path="/parkingPlace/edit/:id" element={<ParkingPlaceEdit />} />
          <Route path="/parkingPlaces" element={<ParkingPlacesPage />} />
          <Route path="/parkingPlace/create" element={<ParkingPlaceCreate />} />
        </>
      )}
      {htmlAppletsEnabled && (
        <>
          <Route path="/htmlApplets" element={<HtmlAppletPage />} />
          <Route path="/htmlApplets/create" element={<HtmlAppletCreate />} />
          <Route path="/htmlApplets/edit/:id" element={<HtmlAppletEdit />} />
        </>
      )}
      <Route path="/faqCategories" element={<FaqCategoryPage />} />
      <Route path="/faqCategories/create" element={<FaqCategoryCreate />} />
      <Route path="/faqCategories/edit/:id" element={<FaqCategoryEdit />} />

      <Route path="/reportCategories" element={<ReportCategoryPage />} />
      <Route
        path="/reportCategories/create"
        element={<ReportCategoryCreate />}
      />
      <Route
        path="/reportCategories/edit/:id"
        element={<ReportCategoryEdit />}
      />

      <Route path="/faqs" element={<FaqsPage />} />
      <Route path="/faqs/create" element={<FaqCreate />} />
      <Route path="/faqs/edit/:id" element={<FaqEdit />} />

      <Route path="/officials" element={<OfficialsPage />} />
      <Route path="/officials/create" element={<OfficialCreate />} />
      <Route path="/officials/edit/:id" element={<OfficialEdit />} />

      <Route path="/onboardingSlides" element={<OnboardingSlidesPage />} />
      <Route
        path="/onboardingSlides/create"
        element={<OnboardingSlideCreate />}
      />
      <Route
        path="/onboardingSlides/edit/:id"
        element={<OnboardingSlideEdit />}
      />

      <Route path="/menuDesigner" element={<MenuItemPage />} />

      <Route path="/contents" element={<ContentPage />} />
      <Route path="/contents/create" element={<ContentCreate />} />
      <Route path="/contents/edit/:id" element={<ContentEdit />} />

      <Route path="/pages" element={<PagePage />} />
      <Route path="/pages/create" element={<PageCreate />} />
      <Route path="/pages/edit/:id" element={<PageEdit />} />

      <Route path="/locations" element={<LocationPage />} />
      <Route path="/locations/create" element={<LocationCreate />} />
      <Route path="/locations/edit/:id" element={<LocationEdit />} />

      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/reports/view/:id" element={<ReportView />} />

      <Route
        path="/systemConfigurations"
        element={<SystemConfigurationsPage />}
      />
      <Route
        path="/systemConfigurations/edit/:id"
        element={<SystemConfigurationEdit />}
      />

      {multiTenancyEnabled && (
        <>
          <Route path="/platform" element={<PlatformDashboardPage />} />
          <Route path="/tenants" element={<TenantPage />} />
          <Route path="/tenants/new" element={<TenantOnboardingWizardPage />} />
          <Route path="/tenants/new/:draftId" element={<TenantOnboardingWizardPage />} />
          <Route path="/tenants/wizard" element={<TenantOnboardingWizardPage />} />
          <Route path="/tenants/wizard/:draftId" element={<TenantOnboardingWizardPage />} />
          <Route path="/tenants/create" element={<TenantCreate />} />
          <Route path="/tenants/edit/:id" element={<TenantEdit />} />
          <Route path="/tenants/:id/overview" element={<TenantOverviewPage />} />
          <Route path="/tenants/:id/admin" element={<TenantAdminPage />} />
          <Route path="/tenant-groups" element={<TenantGroupPage />} />
          <Route path="/tenant-groups/create" element={<TenantGroupEdit />} />
          <Route path="/tenant-groups/edit/:id" element={<TenantGroupEdit />} />
          <Route path="/subscriptions" element={<SubscriptionPage />} />
          <Route path="/subscriptions/create" element={<SubscriptionCreate />} />
          <Route path="/subscriptions/edit/:id" element={<SubscriptionEdit />} />
          <Route path="/licenses" element={<LicensePage />} />
          <Route path="/licenses/create" element={<LicenseCreate />} />
          <Route path="/licenses/edit/:id" element={<LicenseEdit />} />
          <Route path="/role-catalog" element={<RoleCatalogPage />} />
          <Route path="/role-catalog/create" element={<RoleCatalogEdit />} />
          <Route path="/role-catalog/edit/:id" element={<RoleCatalogEdit />} />
        </>
      )}
      <Route path="/invitations" element={<InvitationsPage />} />
      <Route path="/invitations/accept" element={<AcceptInvitationPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route path="/" element={<Dashboard />} />
    </Routes>
  );
};

export default AppRoutes;
